export default __webpack_public_path__ + "static/media/1467.280773f0.png";